import { io } from "socket.io-client";
const socket = io(process.env.REACT_APP_SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false,
});


export default socket;


// import { io } from "socket.io-client";
// import { baseUrl } from "../../const"; 

// const socket = io(baseUrl, {
//   transports: ["websocket"],
//   autoConnect: false,
// });

// export default socket;